import React from 'react';

import { isString, take } from 'lodash';
import { useTranslation } from 'react-i18next';

import { SearchResult } from '@pkg/components/Sections/Groups';
import { DepSearch } from '@pkg/components/deprecated';
import { getPagesContent, useGetGroupFollowers, useGetParamsFromSearchQuery } from '@pkg/hooks';

import { useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

import { type SearchCommonProps } from '../../types';

export function FollowerSearch({
    groupId,
    currentUserId,
    emojiPicker,
    query,
    onQueryChange,
    onSelect,
}: SearchCommonProps) {
    const { t: translate } = useTranslation(['common', 'groups']);

    const isAuthenticated = useAuthTokens((state) => state.isAuthenticated);

    const { emoji: primaryYat, text: twitterHandle } = useGetParamsFromSearchQuery(query);
    const { data: membersRawData, isFetching: membersLoading } = useGetGroupFollowers({
        primaryYat,
        groupId,
        twitterHandle,
        isAuthenticated,
    });

    const membersData = getPagesContent(membersRawData?.pages);
    const users = take(
        membersData.filter((member) => member.id !== currentUserId && isString(member.primary_yat)),
        3,
    );

    return (
        <DepSearch
            placeholder={translate('groups:pods_members_search_placeholder')}
            append={emojiPicker}
            query={query}
            searchResults={users}
            loading={membersLoading}
            resultsFloat={false}
            onQueryChange={onQueryChange}
            onSelect={onSelect}
            Result={(memberResult) => <SearchResult resultIsMember memberResult={memberResult} groupId={groupId} />}
        />
    );
}
